import {Badge} from "@mantine/core"
import {
    Application,
    ApplicationStatus
} from "../types.ts";


const STATUS_CONFIG: Record<ApplicationStatus, { color: string, label: string }> = {
    [ApplicationStatus.ACTIVE]: {
        color: 'green',
        label: 'Active'
    },
    [ApplicationStatus.INACTIVE]: {
        color: 'yellow',
        label: 'Inactive'
    },
};

export const ApplicationStatusBadge = ({record}: { record: Application }) => {

    if (!record?.applicationStatus) {
        return <Badge color='dark'>Invalid Status</Badge>;
    }

    const config = STATUS_CONFIG[record.applicationStatus as ApplicationStatus];
    if (!config) {
        return <Badge color='dark'>{record.applicationStatus}</Badge>;
    }
    return <Badge color={config.color}>{config.label}</Badge>;

}
